module.exports = __webpack_public_path__ + "static/media/exit.78df4c75.png";